/**
 * Created by Vladislav on 29.01.2025.
 */

const EVENTS = {
    STATS: {
        REGISTERED: "registered",
        TRANSIT: "transit",
        DAU: "dau",
        MAU: "mau",
        RETENTION_1: "retention_1",
        RETENTION_2: "retention_2",
        RETENTION_3: "retention_3",
        RETENTION_7: "retention_7",
        RETENTION_14: "retention_14",
        RETENTION_30: "retention_30",

        ACTIVE_TIME: "atime",

        SESSION_TIME: "stime",

        PAYMENTS: "c_payments",
        PAYMENTS_ERROR: "c_payments_error_",
        PAYMENTS_CANCEL: "c_payments_cancel",
        // the store answered after the purchase was already closed (the player closed the overlay, or a timeout): + success | cancel | error
        PAYMENTS_LATE: "c_payments_late_",
        PURCHASE: "c_purchase",
        PAYMENTS_MISSING_PRODUCTS_RECOVERED: "payments_missing_products_recovered-",

        SAMSUNG_LOAD_PRODUCTS: "samsung_load_products",
        SAMSUNG_LOAD_PRODUCTS_SUCCESS: "samsung_load_products_success",
        SAMSUNG_LOAD_PRODUCTS_FAILURE: "samsung_load_products_failure",

        INSTANT_PAYMENT: "instant_payment-",
        INSTANT_PAYMENT_DISABLED_READY: "instant_payment-disabled_ready",
        INSTANT_SUBSCRIPTION_SUPPORTED: "instant_subscription_supported",

        CONNECTOR_VERSION: "connector_version_",
        CONNECTOR_INITIALIZE: "connector_initialize",

        // a native answer nobody waits for any more (late, repeated, from before a reload), itemId: the method
        NATIVE_CALLBACK_DROPPED: "native_callback_dropped",

        ERROR_AMOUNT: "error_amount",

        UPDATE_DEVICE_ID: "update_device_id",
        // the platform swapped the user id after events had gone out under the old one (login): itemId the old id
        UPDATE_USER_ID: "update_user_id"
    },
    ADS: {
        START: "ad_start_",
        FINISH: "ad_finish_",
        CLOSED: "ad_closed_",
        TYPE_COST: "adcost-",
        ERROR_REWARDED: "ad_error_r",
        ERROR_INTERSTITIAL: "ad_error_i"
    },

    CONVERSIONS: {
        VISIT: "visit",
        LEVEL_REACH: "levelreach",
        LEVEL_UP: "levelup",
        PAYMENT: "payment",
        SESSION_TIME: "sessiontime",

        EARN_SOFT: "earnsoft",
        EARN_HARD: "earnhard"
    },

    CLOUD_STORAGE: {
        CONNECT: "cloud_connect-start",
        CONNECT_RESULT: "cloud_connect-",
        CONNECT_SUCCESS: "cloud_connect-success",

        LOAD: "cloud_load",
        LOAD_SUCCESS: "cloud_load_success",

        SAVE: "cloud_save",
        SAVE_SUCCESS: "cloud_save_success",

        DATA_SIZE_BUCKET: "cloud_data_size_bucket-",

        RESOLVE: "cloud_resolve-",
        RESOLVE_INITIALIZE: "cloud_resolve_init-",
        RESOLVE_DISABLE: "cloud_resolve_disable-",
        RESOLVE_EQUALS_DATA: "cloud_resolve-equalsdata",
        CONFLICT: "cloud_conflict",
        CONFLICT_RESOLVED: "cloud_conflict_resolved"
    },

    SYNC_STORAGE: {
        LOAD: "sync_load",
        LOAD_SUCCESS: "sync_load_success",

        SAVE: "sync_save",
        SAVE_SUCCESS: "sync_save_success",

        SAVE_SESSION: "sync_save_session",
        SAVE_SESSION_SUCCESS: "sync_save_session_success",

        DATA_SIZE_BUCKET: "sync_data_size_bucket-",

        RESOLVE: "sync_resolve-"
    },

    PREDICTIONS: {
        PAYMENTS: [{
            conversion_window: 1,
            accumulate: "sum"
        }, {
            conversion_window: 3,
            accumulate: "sum"
        }, {
            conversion_window: 7,
            accumulate: "sum"
        }, {
            conversion_window: 14,
            accumulate: "sum"
        }, {
            conversion_window: 30,
            accumulate: "sum"
        }, {
            conversion_window: 90,
            accumulate: "sum"
        }, {
            conversion_window: 180,
            accumulate: "sum"
        }, {
            conversion_window: 365,
            accumulate: "sum"
        }],

        AD_REVENUE: [{
            conversion_window: 1,
            accumulate: "sum"
        }, {
            conversion_window: 3,
            accumulate: "sum"
        }, {
            conversion_window: 7,
            accumulate: "sum"
        }, {
            conversion_window: 14,
            accumulate: "sum"
        }, {
            conversion_window: 30,
            accumulate: "sum"
        }, {
            conversion_window: 90,
            accumulate: "sum"
        }, {
            conversion_window: 180,
            accumulate: "sum"
        }, {
            conversion_window: 365,
            accumulate: "sum"
        }],

        AD_REWARDED: [{
            conversion_window: 1,
            accumulate: "count"
        }, {
            conversion_window: 3,
            accumulate: "count"
        }, {
            conversion_window: 7,
            accumulate: "count"
        }],

        AD_INTERSTITIAL: [{
            conversion_window: 1,
            accumulate: "count"
        }, {
            conversion_window: 3,
            accumulate: "count"
        }, {
            conversion_window: 7,
            accumulate: "count"
        }]
    }

};

if (typeof connector === "undefined") {
    module.exports = EVENTS;
}